import Icon from '../components/Icon.vue'

Icon.register({
  'blender-phone': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M392 64H558.5L576 0H192V352H480L497.5 288H392C387.6 288 384 284.4 384 280V264C384 259.6 387.6 256 392 256H506.2L523.6 192H392C387.6 192 384 188.4 384 184V168C384 163.6 387.6 160 392 160H532.4L549.8 96H392C387.6 96 384 92.4 384 88V72C384 67.6 387.6 64 392 64zM158.8 335L133 271.8C130.2 264.9 123.2 260.8 115.8 261.5L70.8 265.9C53.5 219 53.1 166.1 70.8 118.2L115.8 122.6C123.2 123.3 130.2 119.1 133 112.4L158.8 49.1C161.8 41.7 159 33.2 152.1 29L112.8 4.9C98.5-3.9 80.1-0.5 69 12-23.6 115.6-23.1 271.5 71 374.5 80.9 385.3 100.2 386.9 112.7 379.3L152.1 355.1C159 350.9 161.8 342.4 158.8 335zM480 384H192C156.7 384 128 412.6 128 448V480C128 497.7 142.3 512 160 512H512C529.7 512 544 497.7 544 480V448C544 412.6 515.4 384 480 384zM336 480C318.3 480 304 465.7 304 448S318.3 416 336 416 368 430.3 368 448 353.7 480 336 480z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/blender-phone.js
// module id = MROF
// module chunks = 144